const LocalStorageService = {
  getLastCuenta () {
    return JSON.parse(localStorage.getItem('lastCuenta'))
  },

  setLastCuenta (cuenta) {
    localStorage.setItem('lastCuenta', JSON.stringify(cuenta))
  },

  removeLastCuenta () {
    localStorage.removeItem('lastCuenta')
  },
}

export default LocalStorageService
